import AddButton from '../../components/Buttons/AddButton';
import ModalCentered from '../../components/ModalCentered';
import { useState, useEffect, useContext } from 'react';
import AddAdminModal from './AddAdminModal';
import { deleteAdministrator, getAdmins } from '../../api/Admin';
import AdminAdministratorTable from './AdminAdministratorTable';
import UpdateAdminModal from './UpdateAdminModal';
import Col from 'react-bootstrap/esm/Col';
import AdministratorCard from './AdministratorCard';
import { UserContext } from '../../App';
import CustomToast from '../../components/CustomToast';
import Spinner from 'react-bootstrap/esm/Spinner';
import Loading from '../../components/Loading';

function AdminAdministrator() {
  const [adminList, setAdminList] = useState({});
  const [chosenAdmin, setChosenAdmin] = useState();
  const [chosenAdminId, setChosenAdminId] = useState('');
  const [newAdministratorModalShow, setNewAdministratorModalShow] =
    useState(false);
  const [updateAdministratorModalShow, setUpdateAdministratorModalShow] =
    useState(false);
  const [deleteAdministratorShow, setDeleteAdministratorShow] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState();
  const [toastTitle, setToastTitle] = useState();
  const [toastBody, setToastBody] = useState();
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  const userContext = useContext(UserContext);

  useEffect(() => {
    async function fetchAdministrators() {
      const result = await getAdmins();
      if (result) {
        setAdminList(result.list);
        setLoading(false);
      }
    }

    fetchAdministrators();
  }, [
    newAdministratorModalShow,
    updateAdministratorModalShow,
    deleteAdministratorShow,
  ]);

  const deleteAdmin = async () => {
    setUpdating(true);
    if (userContext.user?.id !== chosenAdminId) {
      const result = await deleteAdministrator(chosenAdminId);
      if (result) {
        switch (result.statusCode) {
          case 200:
            setToastType('success');
            setToastTitle('Administratör borttagen');
            setToastBody('Administratören har blivit permanent borttagen');
            break;
          default:
            setToastType('danger');
            setToastTitle('Administratör ej borttagen');
            setToastBody('Administratören kunde inte bli borttagen');
        }
        setShowToast(true);
      }
    }
    setDeleteAdministratorShow(false);
    setUpdating(false);
  };

  const deleteAdminModalBody = (
    <>
      {userContext.user?.id === chosenAdminId ? (
        <span>Du kan inte radera den inloggade administratören.</span>
      ) : (
        <span>Är du säker på att du vill ta bort administratören?</span>
      )}
    </>
  );

  const deleteAdminModalConfirmBtn = (
    <>
      {userContext.user?.id === chosenAdminId ? (
        'OK'
      ) : updating ? (
        <>
          <Spinner
            as='span'
            animation='border'
            size='sm'
            role='status'
            aria-hidden='true'
            className='me-2'
          />
          <span className='visually-hidden'>Loading...</span>
          Ta bort
        </>
      ) : (
        'Ta bort'
      )}
    </>
  );

  return (
    <>
      <AddButton
        text='Ny administratör'
        onClick={() => setNewAdministratorModalShow(true)}
        className='mb-4 mt-2'
      />

      <hr />

      {loading ? (
        <div className='d-flex justify-content-center align-items-center mt-5 mb-5'>
          <Loading size='100px' text='Laddar administratörer' />
        </div>
      ) : adminList && adminList.length > 0 ? (
        <>
          <Col className='d-none d-xl-flex mt-2'>
            <AdminAdministratorTable
              adminList={adminList}
              onDelete={() => setDeleteAdministratorShow(true)}
              onEdit={() => setUpdateAdministratorModalShow(true)}
              chosenAdmin={setChosenAdmin}
              chosenAdminId={setChosenAdminId}
            />
          </Col>
          <Col className='d-flex flex-column gap-3 d-xl-none mt-2'>
            {adminList.map((a, index) => {
              return (
                <AdministratorCard
                  key={index}
                  administrator={a}
                  chosenAdmin={setChosenAdmin}
                  chosenAdminId={setChosenAdminId}
                  onDelete={() => setDeleteAdministratorShow(true)}
                  onEdit={() => setUpdateAdministratorModalShow(true)}
                />
              );
            })}
          </Col>
        </>
      ) : (
        <></>
      )}

      <AddAdminModal
        show={newAdministratorModalShow}
        onHide={() => setNewAdministratorModalShow(false)}
        admins={adminList}
        setToastType={setToastType}
        setToastTitle={setToastTitle}
        setToastBody={setToastBody}
        setShowToast={setShowToast}
      />
      <UpdateAdminModal
        admin={chosenAdmin}
        setToastType={setToastType}
        setToastTitle={setToastTitle}
        setToastBody={setToastBody}
        setShowToast={setShowToast}
        show={updateAdministratorModalShow}
        onHide={() => setUpdateAdministratorModalShow(false)}
      />
      <ModalCentered
        header='Ta bort administratör'
        body={deleteAdminModalBody}
        confirmBtnText={deleteAdminModalConfirmBtn}
        onConfirm={() => {
          deleteAdmin();
        }}
        show={deleteAdministratorShow}
        onHide={() => setDeleteAdministratorShow(false)}
      />
      <CustomToast
        type={toastType}
        title={toastTitle}
        body={toastBody}
        show={showToast}
        onClose={() => setShowToast(false)}
      />
    </>
  );
}

export default AdminAdministrator;
